import {Component, DestroyRef, inject, signal, Signal} from '@angular/core';
import {BackButton} from '../../../assets/shared/back-button/back-button';
import {ActivatedRoute, Router} from '@angular/router';
import {anketaData} from '../../data/anketaData';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {SelectModule} from 'primeng/select';
import {FormsModule} from '@angular/forms';
import {AnketaModule, OptionAnketa} from '../../core/interface/anketa.interface';
import {CommonModule} from '@angular/common';
import {TextareaModule} from 'primeng/textarea';
import {InputTextModule} from 'primeng/inputtext';
import {RadioButton} from 'primeng/radiobutton';
import {AnketaResult, OtherInput} from './interfaces/anketa.interface';
import {AnketaService} from '../../core/service/anketa/anketa.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {RegionStore} from '../../core/store/region/region.store';
import {NotificationService} from '../../../assets/shared/notification/notification.service';
import {Region} from '../../core/store/region/region.interface';
import {ConfirmationModal} from '../../../assets/shared/modal/confirmation-modal/confirmation-modal';


@Component({
  selector: 'anketa',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, BackButton, SelectModule, InputTextModule, TextareaModule, CommonModule, RadioButton, ConfirmationModal,],
  templateUrl: './anketa.html',
  styleUrl: './anketa.scss',
})
export class Anketa{
  private notification = inject(NotificationService);
  private destroy = inject(DestroyRef);
  private anketaService = inject(AnketaService)
  private regionStore  = inject(RegionStore)
  private result: AnketaResult[] = [];
  public anketaForm!: FormGroup;
  public anketaData:AnketaModule[] = anketaData
  public currentStep:number = 0;
  public regions: Signal<Region[]> = this.regionStore.region;
  private coursesId?: string;
  public isModalSuccess = signal<boolean>(false)

  constructor(private router:Router, private activeRouter:ActivatedRoute ) {
    // this.createForm();
  }


  ngOnInit(){
    this.coursesId = this.activeRouter.snapshot.parent?.paramMap.get('coursesId')!;
    this.router.navigate([this.coursesId])
  }

  private createForm(): void {
    const blocks: Record<string, FormGroup> = {};
    this.anketaData.forEach((block, blockIndex) => {
      const controls: Record<string, FormControl> = {};

      block.data.forEach(question => {
        if (question.controlName) {
          controls[question.controlName] = new FormControl(null,question.required ? Validators.required : []);
        }

        if (question.options && question.options.length > 0) {

          const options = question.options;
          const uniqueControlNames: string[] = [...new Set(options.map(o => o.controlName).filter((name): name is string => !!name))];

          uniqueControlNames.forEach((controlName: string) => {
          if (controls.hasOwnProperty(controlName)) return;
            const option = options.find(o => o.controlName === controlName);
            const isTextarea = option?.type === 'textarea';
            const isRequired = option?.required ?? question.required ?? false;

            controls[controlName] = new FormControl(null, isRequired ? Validators.required : []);
            if (isTextarea) {
              controls[controlName].disable();
            }
          });
        }
      });
      blocks[`block${blockIndex + 1}`] = new FormGroup(controls);
    });

    this.anketaForm = new FormGroup(blocks);
  }


  get currentBlock(): FormGroup {
    return this.anketaForm.get(`block${this.currentStep + 1}`) as FormGroup;
  }

  private createAnketa(){
    this.anketaService.createAnketa(this.result[0])
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe({
        next: res => {
          this.isModalSuccess.set(true)
          document.body.classList.add('no-scroll');
        },
        error: err => {
          this.notification.show('error', `${err?.error?.detail || 'Произошла ошибка'}`, '');
        }
      });
  }


  public navigateHome(){
    this.isModalSuccess.set(false)
    document.body.classList.remove('no-scroll');
    this.router.navigate([this.coursesId])
  }
  get isLastStep(): boolean {return !!this.anketaData?.length &&  this.currentStep === this.anketaData.length - 1;}



  public onRadioChange(option: OptionAnketa) {
    const radioControl = this.currentBlock.get(String(option.controlName));
    const textareaControl = this.currentBlock.get(`${option.controlName}-textarea`);
    if (!radioControl || !textareaControl) return;
    if (radioControl.value === 'other') {
      textareaControl.enable();
    } else {
      textareaControl.disable();
    }

    radioControl.valueChanges.subscribe(value => {
      if (value === 'other') {
        textareaControl.enable();
      } else {
        textareaControl.disable();
        textareaControl.setValue(null);
      }
    });
  }


  private buildAnswers(blockValue: Record<string, any>, questions: any[]): string[] {
    return Object.keys(blockValue)
      .filter(key => {
        if (blockValue[key] === 'other') return false;

        if (key.endsWith('-textarea')) {
          const baseKey = key.replace('-textarea', '');
          return blockValue[baseKey] === 'other';
        }
        return true;
      })
      .map(key => {
        const question = questions.find(q => {
          if (q.controlName === key) return true;
          if (q.options?.length) {
            return q.options.some((opt:OptionAnketa) => opt.controlName === key);
          }
          return false;
        });

        return `{"question":"${question?.title || ''}","answer":"${blockValue[key]}"}`;
      });
  }

  public nextStep() {
    if (this.currentBlock.invalid) {
      this.currentBlock.markAllAsTouched();
      return;
    }

    const blockValue = this.currentBlock.value;

    if (!this.result.length) {
      this.result.push({
        courseId: Number(this.coursesId),
        questionAndAnswer: [] as string[],
      });
    }

    const currentModuleQuestions = this.anketaData[this.currentStep]?.data || [];

    const newQnA = this.buildAnswers(blockValue, currentModuleQuestions);

    this.result[0].questionAndAnswer.push(...newQnA);

    if (!this.isLastStep) {
      this.currentStep++;
      setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
    } else {
       this.createAnketa();
    }
  }
  protected readonly String = String;
}
